/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_NameInputs */

const cs_pipelines_name = /** @type {(inputs: Pipelines_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název`)
};

const en_pipelines_name = /** @type {(inputs: Pipelines_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Pipelines_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_name = /** @type {((inputs?: Pipelines_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_name(inputs)
	return cs_pipelines_name(inputs)
});